<template>
  <div class="details-audio">
    <div class="details-audio__inner">
      <audio ref="audio" class="details-audio__media" @loadedmetadata="handleAudioData">
        <source src="/audio.mp3" type="audio/mpeg">
      </audio>
      <div class="details-audio__player">
        <div class="details-audio__player-bar"/>
        <svg
          version="1.1"
          x="0px"
          y="0px"
          viewBox="0 0 201 36"
          style="enable-background:new 0 0 201 36;"
          xml:space="preserve"
          class="details-audio__player-progress"
        >
          <path
            ref="progress"
            style="fill:none;stroke:#ffffff;stroke-width:4px;"
            stroke-dasharray="293.305px"
            d="M 0,34 C 16.8,34 16.7,2 33.5,2 50.3,2 50.3,34 67,34 83.8,34 83.8,2 100.5,2 c 16.8,0 16.8,32 33.5,32 16.8,0 16.8,-32 33.5,-32 16.8,0 16.8,32 33.5,32"
          />
        </svg>
        <button
          class="details-audio__control details-audio__control--play"
          @click="handleClick"
        >
          <img :src="icon" alt="">
        </button>
        {{ time }}
      </div>
    </div>
  </div>
</template>

<script>
import anime from 'animejs'

export default {
  data () {
    return {
      paused: true,
      currentTime: 0,
      canPlay: false
    }
  },
  computed: {
    icon () {
      return this.paused ? '/img/play.svg' : '/img/pause.svg'
    },
    time () {
      return `${ String(Math.floor(this.currentTime / 60)).padStart(2, '0') }:${ String(Math.floor(this.currentTime % 60)).padStart(2, '0') }`
    }
  },
  watch: {
    currentTime () {
      this.progressAnimation.pause()
      this.progressAnimation.seek(this.currentTime * 1000)
      this.progressAnimation.play()
    }
  },
  methods: {
    handleAudioData () {
      const { audio, progress } = this.$refs

      this.canPlay = true
      this.progressAnimation = anime({
        targets: progress,
        strokeDashoffset: [anime.setDashoffset, 0],
        strokeWidth: [3.5, 4],
        easing: 'linear',
        duration: audio.duration * 1000,
        autoplay: false
      })
    },
    handleClick () {
      if (!this.canPlay) return

      const { audio } = this.$refs

      if (this.paused) {
        audio.play()
        this.setCurrentTime()
        this.progressAnimation.play()
      } else {
        this.progressAnimation.pause()
        clearTimeout(this.timeout)
        audio.pause()
      }

      this.paused = !this.paused
    },
    setCurrentTime () {
      const { audio } = this.$refs
      this.currentTime = audio.currentTime

      if (audio.currentTime >= audio.duration) {
        this.paused = true
        clearTimeout(this.timeout)
      } else {
        this.timeout = setTimeout(this.setCurrentTime.bind(this), 200)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .details-audio {
    padding: 16px 0;

    &__player {
      display: flex;
      align-items: center;
      position: relative;
    }

    &__player-progress {
      width: 200px;
      position: absolute;
      top: 0;
      left: 0;

      path {
        will-change: stroke-dashoffset, stroke-dasharray;
      }
    }

    &__player-bar {
      width: 200px;
      height: 36px;
      position: relative;

      &::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        height: 3px;
        background-color: #590808;
      }
    }

    &__control {
      padding: 10px;
      transition: opacity $base-transition;

      &:hover {
        opacity: .85;
      }

      &--play {
        @include reset-button;
        padding-top: 1px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Details/DetailsAudio.vue